"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureItem = void 0;
class AdventureItem {
    constructor(data) {
        this.tag = data.tag;
        this.name = data.name;
        this.description = data.description;
        this.iconId = data.iconId;
    }
    hasDescription() {
        return !!this.description;
    }
    hasIcon() {
        return !!this.iconId;
    }
    toJSON() {
        return {
            tag: this.tag,
            name: this.name,
            description: this.description,
            iconId: this.iconId
        };
    }
}
exports.AdventureItem = AdventureItem;
//# sourceMappingURL=AdventureItem.js.map